import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
import { Mutation } from 'react-apollo';
import Skeleton from '@material-ui/lab/Skeleton';
//styles and icons 
import { Paper, Button, TextField, InputLabel, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import { Row, Col, Modal } from 'react-bootstrap';
import educationIcon from '../../../images/education.svg';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

// this component represent the profile Education part in explore opportunities page 
class Education extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titleErrorMessage: '',
            schoolErrorMessage: '',
            descriptionErrorMessage: '',
            dateErrorMessage : ''
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            //handle fetch specialities and tags dropdown   
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                        user(id: $user_id){
                        id
                        Educations {
                            id
                            title
                            at_name
                            bio
                            start_time
                            finish_time
                            created_at
                          }
                  }
              }
       `, variables: { user_id: id }
            }).then(res => {
                this.setState({ ...this.state, userData: res.data.user });
            });
        }
    }
    componentWillMount() {
        this.getUserData();
        this.getToday();
        setInterval(function () {
            let checkBox = document.querySelector('#checkeDate');
            let endDate = document.querySelector('.endTime');
            if (checkBox && endDate) {
                if (checkBox.checked === true) {
                    endDate.classList.add('d-none');
                    document.querySelector('#endDate').value = ''
                }
                else {
                    endDate.classList.remove('d-none');
                }
            }
        }, 100);
    }
    getToday = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today =  yyyy+ '-' +mm ;
        console.log(today);
        this.setState({...this.state , today : today});
    }
    compare_dates = function(date1,date2){
        let stillWorkThere = document.querySelector('#checkeDate').checked;

        if (date1>date2)  this.setState({...this.state , dateErrorMessage : 'Please choose valid end date'})
        else if(date1<date2) { console.log("in else");  this.setState({...this.state , dateErrorMessage : ''}); }
        else if(date1 === null || date2 === null) this.setState({...this.state , dateErrorMessage : ''});
        else if(stillWorkThere) this.setState({...this.state , dateErrorMessage : ''});
        else  this.setState({...this.state , dateErrorMessage : 'Please choose valid end date'})

     }
    checkDate = ()=> {
        let start_date = document.querySelector('#startDate').value;
        let end_date = document.querySelector('#endDate').value;
        console.log(start_date , end_date);
        this.compare_dates(new Date(start_date ), new Date(end_date));
    }
    closeEducation = () => this.setState({ ...this.state, showeducation: false, titleErrorMessage: '', schoolErrorMessage: '', descriptionErrorMessage: '', editEducation: '' });
    handleChange = (e) => document.querySelector('.endTime').classList.toggle('d-none');
    handleSaveData = () => {
        if (this.state.titleErrorMessage === '' && this.state.schoolErrorMessage === ''
         && this.state.descriptionErrorMessage === '' && this.state.dateErrorMessage === '') {
            let title, school, start_date, end_date, description;
            description = document.querySelector('#description').value
            if (document.querySelector('#title').value) {
                title = document.querySelector('#title').value
                document.querySelector('#title').classList.remove('border', 'border-danger')
            }
            else {
                document.querySelector('#title').classList.add('border', 'border-danger')
            }
            if (document.querySelector('#school').value) {
                school = document.querySelector('#school').value
                document.querySelector('#school').classList.remove('border', 'border-danger');
            }
            else {
                document.querySelector('#school').classList.add('border', 'border-danger');
            }
            if (document.querySelector('#startDate').value) {
                start_date = document.querySelector('#startDate').value
                document.querySelector('#startDate').classList.remove('border', 'border-danger');
            }
            else {
                document.querySelector('#startDate').classList.add('border', 'border-danger');
            }
            if (document.querySelector('#checkeDate').checked === false) {
                if (document.querySelector('#endDate').value) {
                    end_date = document.querySelector('#endDate').value
                    document.querySelector('#endDate').classList.remove('border', 'border-danger');
                } else {
                    document.querySelector('#endDate').classList.add('border', 'border-danger');

                }
                if (title && school && start_date && end_date) {
                    if (this.state.editEducation) {
                        this.props.edit_education({
                            variables: {
                                id: this.state.editEducation.id,
                                title: title,
                                at_name: school,
                                bio: description,
                                start_time: start_date+'-01',
                                finish_time: end_date+'-01'
                            }
                        }).then((res, loading) => {
                            if (res.data.Userupdate.Status.code === 200) {
                                let updateddata = res.data.Userupdate.user;
                                this.setState({ ...this.state, userData: updateddata })
                                this.closeEducation();
                            }
                        }).catch((err) => console.log(err));
                    }
                    else {
                        this.props.save_education({
                            variables: {
                                title: title,
                                at_name: school,
                                bio: description,
                                start_time: start_date+'-01',
                                finish_time: end_date+'-01'
                            }
                        }).then((res, loading) => {
                            if (res.data.Userupdate.Status.code === 200) {
                                let updateddata = res.data.Userupdate.user;
                                this.setState({ ...this.state, userData: updateddata })
                                this.closeEducation();
                            }
                        }).catch((err) => console.log(err));
                    }
                }
            }
            else {
                if (title && school && start_date) {
                    if (this.state.editEducation) {
                        this.props.edit_education({
                            variables: {
                                id: this.state.editEducation.id,
                                title: title,
                                at_name: school,
                                bio: description,
                                start_time: start_date+'-01',
                                finish_time: ''
                            }
                        }).then((res, loading) => {
                            if (res.data.Userupdate.Status.code === 200) {
                                let updateddata = res.data.Userupdate.user;
                                this.setState({ ...this.state, userData: updateddata })
                                this.closeEducation();
                            }
                        }).catch((err) => console.log(err));
                    }
                    else {
                        this.props.save_education({
                            variables: {
                                title: title,
                                at_name: school,
                                bio: description,
                                start_time: start_date+'-01',
                                finish_time: ''
                            }
                        }).then((res, loading) => {
                            if (res.data.Userupdate.Status.code === 200) {
                                let updateddata = res.data.Userupdate.user;
                                this.setState({ ...this.state, userData: updateddata })
                                this.closeEducation();
                            }
                        }).catch((err) => console.log(err));
                    }
                }
            }
        }
    }
    handleDelete = (id) => {
        let arr = []
        arr.push(id)
        this.props.delete_education({
            variables: {
                RemoveEducations: arr
            }
        }).then((res, loading) => {
            if (res.data.Userupdate.Status.code === 200) {
                let updateddata = res.data.Userupdate.user;
                this.setState({ ...this.state, userData: updateddata, waiting: false })
            }
            if (loading) this.setState({ ...this.state, waiting: true })
        }).catch((err) => console.log(err));

    }
    handleEdit = (workExperience) => {
        this.setState({ ...this.state, showeducation: true, editEducation: workExperience ,
            startDate : workExperience.start_time.substring(0,7)  , endDate : (workExperience.finish_time)?workExperience.finish_time.substring(0,7) : ''})
    }
    render() {
        if (!this.state.userData) {
            return (
                <div className="">
                    <Skeleton animation="wave" width={170} height={40} />
                    <Skeleton className="mb-2" variant="rect" animation="wave" height={360} />
                </div>
            )
        }
        else {
            return (
                <div className="workExperience mt-4">
                    <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0 ">
                                        <h6 className="bold mb-0">
                                            <span ><img src={educationIcon} className="pr-3" alt="icon" /></span>
                                            Education</h6>
                                    </Col>
                                    <Col className="text-right p-0">
                                        <button
                                            onClick={e => this.setState({ ...this.state, showeducation: true })}
                                            className="bg-transparent border-0">
                                            <h6>
                                                Add new
                                                </h6>
                                        </button>
                                    </Col>
                                </Row>
                                {(this.state.userData.Educations) ?
                                    this.state.userData.Educations.map(education =>
                                        <Row key={education.id} id={education.id} className="m-0">
                                            <Col xs={9} className="p-0">
                                                <h6 className="captialize bold">{education.title + ' at ' + education.at_name}</h6>
                                                <div><p className="text-grey mb-0">
                                                    {education.start_time.substring(0,7)} - {(education.finish_time) ? education.finish_time.substring(0,7) : 'Present'}</p>
                                                </div>
                                            </Col>
                                            <Col className="text-right">
                                                <button
                                                    onClick={e => this.handleEdit(education)}
                                                    className="bg-transparent border-0 text-dark"
                                                >
                                                    <EditIcon style={{ fontSize: '1rem' }} />
                                                </button>
                                                <button
                                                    onClick={e => this.handleDelete(education.id)}
                                                    className="bg-transparent border-0 text-dark"
                                                >
                                                    <DeleteIcon style={{ fontSize: '1rem' }} />
                                                </button>
                                            </Col>
                                            <Col md={9} className="p-0">
                                                <p>{(education.bio) ? education.bio : ''}</p>
                                            </Col>
                                            <Col xs={12} className="border-bottom mt-2 mb-2"></Col>
                                        </Row>)
                                    : ''}
                            </Col>
                            <Modal
                                size="md"
                                centered
                                className="row m-0  pr-0"
                                show={this.state.showeducation}
                                onHide={this.closeEducation}>
                                <Col xs={12} className="p-0">
                                    <Modal.Header className="p-2 pr-3 pl-3 bg-lightgrey" closeButton>
                                        <Modal.Title className="h5 ">Education</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="p-4">
                                        {/* field of study */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="title">
                                                <p className="mb-1"> Field of study </p>
                                            </InputLabel>
                                            <TextField
                                                defaultValue={(this.state.editEducation) ? this.state.editEducation.title : ''}
                                                required
                                                id="title"
                                                name="title"
                                                onChange={e => {
                                                    if (e.target.value.length < 3 || e.target.value.length > 32) {
                                                        this.setState({ ...this.state, titleErrorMessage: 'Field of study must be between 3 and 32 characters long.' });
                                                        return false;

                                                    } else {
                                                        this.setState({ ...this.state, titleErrorMessage: '' });
                                                        e.target.classList.remove('border', 'border-danger');
                                                        return true;
                                                    }
                                                }}
                                                className="p-0"
                                                placeholder=""
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.titleErrorMessage}</Typography>
                                            </Col>
                                        </div>
                                        {/* school name */}
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="school">
                                                <p className="mb-1"> School</p>
                                            </InputLabel>
                                            <TextField
                                                defaultValue={(this.state.editEducation) ? this.state.editEducation.at_name : ''}
                                                required
                                                id="school"
                                                name="school"
                                                onChange={e => {
                                                    if (e.target.value.length < 3 || e.target.value.length > 32) {
                                                        this.setState({ ...this.state, schoolErrorMessage: 'school name must be between 3 and 32 characters long.' });
                                                        return false;

                                                    } else {
                                                        this.setState({ ...this.state, schoolErrorMessage: '' });
                                                        e.target.classList.remove('border', 'border-danger');
                                                        return true;
                                                    }
                                                }}
                                                className="p-0"
                                                placeholder=""
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.schoolErrorMessage}</Typography>
                                            </Col>
                                        </div>
                                        {/* start & end date */}
                                        <div className="mb-3 row align-items-center">
                                            <Col sm={6} className="">
                                                <InputLabel className="" htmlFor="date">
                                                    <p className="mb-1">Start Date</p>
                                                </InputLabel>
                                                <TextField
                                                    defaultValue={(this.state.editEducation) ? this.state.editEducation.start_time.substring(0,7) : ''}
                                                    required
                                                    fullWidth
                                                    type="month"
                                                    id="startDate"
                                                    name="startDate"
                                                    className="p-0"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{
                                                        max: this.state.today
                                                    }}
                                                    onChange={e => {
                                                        this.setState({...this.state , startDate : e.target.value});
                                                        e.target.classList.remove('border', 'border-danger');
                                                        this.checkDate();
                                                    }}
                                                />
                                            </Col>
                                            <Col sm={6} className="p-0">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            defaultChecked={(this.state.editEducation) ? (this.state.editEducation.finish_time) ? false : true : true}
                                                            onChange={e=>{
                                                                this.handleChange();
                                                                this.setState({...this.state , dateErrorMessage : ''})
                                                            }}
                                                            name="checkeDate"
                                                            id="checkeDate"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="I'm currently studying there"
                                                    size="small"
                                                />
                                            </Col>
                                            <Col sm={6} className="endTime pt-2">
                                                <InputLabel className="" htmlFor="date">
                                                    <p className="mb-1">End Date</p>
                                                </InputLabel>
                                                <TextField
                                                    fullWidth
                                                    defaultValue={(this.state.editEducation) ? (this.state.editEducation.finish_time)?this.state.editEducation.finish_time.substring(0,7) : '' : ''}
                                                    type="month"
                                                    id="endDate"
                                                    name="endDate"
                                                    onChange={e => {
                                                        this.setState({...this.state , endDate : e.target.value});
                                                        document.querySelector('#endDate').classList.remove('border', 'border-danger');
                                                        this.checkDate();
                                                    }}
                                                    className="p-0"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{
                                                        max: this.state.today
                                                    }}
                                                />
                                            </Col>
                                            <Col xs={12}>
                                                <Typography variant="subtitle1" className="text-danger">{this.state.dateErrorMessage}</Typography>
                                            </Col>
                                        </div>
                                        {/* Description */}
                                        <div>
                                            <InputLabel htmlFor="description">
                                                Description
                                            </InputLabel>
                                            <TextField
                                                name="description"
                                                id="description"
                                                className="pt-1 pb-1"
                                                multiline
                                                rows="3"
                                                fullWidth
                                                variant="outlined"
                                                helperText="0 / 5000 Characters"
                                                onChange={e => {
                                                    if (e.target.value.length > 500) {
                                                        this.setState({ ...this.state, descriptionErrorMessage: 'Description should be maximum 500 characters long.' });
                                                        return false;

                                                    } else {
                                                        this.setState({ ...this.state, descriptionErrorMessage: '' });
                                                        return true;
                                                    }
                                                }}
                                            />
                                            <Col xs={12} className="p-0">
                                                <Typography variant="subtitle1" className="text-danger">{this.state.descriptionErrorMessage}</Typography>
                                            </Col>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer className="custom pr-3 pl-3 border-0">
                                        <Row className="m-0 w-100">
                                            <Col xs={6} className="text-left p-0">
                                                <Button
                                                    type="button"
                                                    size="large"
                                                    className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                    onClick={() => this.closeEducation()}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                            <Col xs={6} className="text-right p-0">
                                                <div>
                                                    <Button
                                                        type="button"
                                                        size="large"
                                                        className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                        onClick={this.handleSaveData}>
                                                        Save
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Modal.Footer>
                                </Col>
                            </Modal>
                        </Row>
                    </Paper>
                </div>
            )
        }
    }
}
const SAVE_EDUCATION = gql`
mutation($title : Title !   $at_name : Title !  $bio : Text
    $start_time : Date !  $finish_time : Date
  ){
    Userupdate(data:
      {
        AddEducations :[{
          title : $title ,
                at_name : $at_name,
                bio : $bio,
                start_time :  $start_time,
                finish_time : $finish_time
        }]
      }){
      user {
        id
        Educations {
          id
          title
          at_name
          bio
          start_time
          finish_time
        }
      }
      Status {
        code
        message
      }
    }
  } 
`
const EDIT_EDUCATION = gql`
mutation($title : Title !   $at_name : Title !  $bio : Text
    $start_time : Date !  $finish_time : Date , $id : Int !
  ){
    Userupdate(data:
      {
        EditEducations : [{
          id : $id , 
          data : {
          title : $title ,
                at_name : $at_name,
                bio : $bio,
                start_time :  $start_time,
                finish_time : $finish_time
          }
        }]
      }){
      user {
        id
        Educations {
          id
          title
          at_name
          bio
          start_time
          finish_time
        }
      }
      Status {
        code
        message
      }
    }
  } 
  `
const DELETE_EDUCATION = gql`
mutation($RemoveEducations : [Int !]
    ){
      Userupdate(data:
        {
          RemoveEducations : $RemoveEducations
        }){
        user {
          id
          Educations {
            id
            title
            at_name
            bio
            start_time
            finish_time
          }
        }
        Status {
          code
          message
        }
      }
    } 
`

export default compose(
    graphql(SAVE_EDUCATION, {
        name: 'save_education'
    }),
    graphql(EDIT_EDUCATION, {
        name: 'edit_education'
    }),
    graphql(DELETE_EDUCATION, {
        name: 'delete_education'
    })
)(withRouter(Education))